export default "__VITE_ASSET__DgBBuzm6__"